if (!customElements.get('pdp-accordion-tabs')) {
  class PdpAccordionTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-tab]');
      this.panels = this.querySelectorAll(':scope > [data-panel]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.activate(button.dataset.tab));
      });
    }

    activate(tabId) {
      this.buttons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.tab === tabId);
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.panel === tabId);
      });
    }
  }

  customElements.define('pdp-accordion-tabs', PdpAccordionTabs);
}

if (!window.__pdpAccordionExclusiveInitialized) {
  window.__pdpAccordionExclusiveInitialized = true;

  const ACCORDION_EASE = '0.4s cubic-bezier(0.4, 0, 0.2, 1)';

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const clearAccordionInline = (content) => {
    content.style.height = '';
    content.style.overflow = '';
    content.style.transition = '';
    content.style.paddingBottom = '';
  };

  const animateAccordion = (details, shouldOpen) => {
    const content = details.querySelector(':scope > .pdp-accordion__content');
    if (!content) {
      details.open = shouldOpen;
      return;
    }

    if (prefersReducedMotion()) {
      details.open = shouldOpen;
      clearAccordionInline(content);
      return;
    }

    const run = (startHeight, endHeight, startPad, endPad, onDone) => {
      content.style.overflow = 'hidden';
      content.style.transition = 'none';
      content.style.height = `${startHeight}px`;
      content.style.paddingBottom = startPad;
      void content.offsetHeight;
      content.style.transition = `height ${ACCORDION_EASE}, padding-bottom ${ACCORDION_EASE}`;
      content.style.height = `${endHeight}px`;
      content.style.paddingBottom = endPad;

      const finish = (event) => {
        if (event && event.target !== content) return;
        if (event && event.propertyName && event.propertyName !== 'height') return;
        content.removeEventListener('transitionend', finish);
        window.clearTimeout(content._accordionTimer);
        onDone();
      };

      content.addEventListener('transitionend', finish);
      content._accordionTimer = window.setTimeout(finish, 450);
    };

    details.dataset.animating = 'true';
    const naturalPad = getComputedStyle(content).paddingBottom || '24px';

    if (shouldOpen) {
      details.open = true;
      const target = content.scrollHeight;
      run(0, target, '0px', naturalPad, () => {
        clearAccordionInline(content);
        details.dataset.animating = 'false';
      });
      return;
    }

    run(content.scrollHeight, 0, naturalPad, '0px', () => {
      details.open = false;
      clearAccordionInline(content);
      details.dataset.animating = 'false';
    });
  };

  const initExclusiveAccordions = () => {
    document.querySelectorAll('.pdp-accordion details').forEach((details) => {
      if (details.dataset.animateBound === 'true') return;
      details.dataset.animateBound = 'true';

      const summary = details.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (details.dataset.animating === 'true') return;

        const group = details.closest('.pdp-accordion-group');
        if (!details.open && group) {
          group.querySelectorAll('details[open]').forEach((other) => {
            if (other !== details) animateAccordion(other, false);
          });
        }

        animateAccordion(details, !details.open);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExclusiveAccordions);
  } else {
    initExclusiveAccordions();
  }

  document.addEventListener('shopify:section:load', initExclusiveAccordions);
}

if (!window.__pdpIngredientPopupsInitialized) {
  window.__pdpIngredientPopupsInitialized = true;

  const mountPdpIngredientOverlays = () => {
    document.querySelectorAll('.pdp-accordion-popup-overlay').forEach((overlay) => {
      if (overlay.parentElement === document.body) return;

      const existing = document.getElementById(overlay.id);
      if (existing && existing !== overlay && existing.parentElement === document.body) {
        existing.remove();
      }

      document.body.appendChild(overlay);
    });
  };

  const closeOverlay = (overlay) => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  };

  const openOverlay = (overlay) => {
    mountPdpIngredientOverlays();
    overlay.classList.add('is-open');
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    const closeButton = overlay.querySelector('.pdp-accordion-popup__close');
    if (closeButton) closeButton.focus();
  };

  const initPdpIngredientPopups = () => {
    mountPdpIngredientOverlays();

    document.querySelectorAll('.pdp-ingredients-popup-trigger').forEach((trigger) => {
      if (trigger.dataset.popupBound === 'true') return;
      trigger.dataset.popupBound = 'true';
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        const overlay = document.getElementById(this.dataset.popupId);
        if (overlay) openOverlay(overlay);
      });
    });

    document.querySelectorAll('.pdp-accordion-popup-overlay').forEach((overlay) => {
      if (overlay.dataset.popupBound === 'true') return;
      overlay.dataset.popupBound = 'true';

      const closeButton = overlay.querySelector('.pdp-accordion-popup__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => closeOverlay(overlay));
      }

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closeOverlay(overlay);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpIngredientPopups);
  } else {
    initPdpIngredientPopups();
  }

  document.addEventListener('shopify:section:load', initPdpIngredientPopups);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.pdp-accordion-popup-overlay.is-open').forEach(closeOverlay);
  });
}
